import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureCreditScoreAccountSummary(props) {
    return <AccountSummaryPage />
}